/* Forms marked data-tl-no-ajax must post normally: Shopify drops properties[] file
   uploads on AJAX adds. */
document.addEventListener('submit', function (e) {
  var f = e.target;
  if (f && f.matches && f.matches('form[data-tl-no-ajax]')) { e.stopImmediatePropagation(); }
}, true);

/* Thorns London — storefront behaviour.
   Rose rotator, character gauges, FAQ panels, sticky one-page nav,
   Royal Mail lookup, AJAX cart drawer. */
(function () {
  'use strict';
  var MAX = 7;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---- rose ------------------------------------------------------------- */
  function initRose(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    var stage = $('[data-tl-stage]', root), rotor = $('[data-tl-rotor]', root);
    if (!stage || !rotor) return;
    var angle = 0, dragging = false, lastX = 0;
    function render() { rotor.style.transform = 'rotateY(' + angle.toFixed(1) + 'deg)'; }
    function px(e) { return e.touches && e.touches.length ? e.touches[0].clientX : e.clientX; }
    stage.addEventListener('mousedown', function (e) { dragging = true; lastX = px(e); });
    stage.addEventListener('touchstart', function (e) { dragging = true; lastX = px(e); }, { passive: true });
    window.addEventListener('mousemove', function (e) { if (dragging) { angle += (px(e) - lastX) * 0.55; lastX = px(e); render(); } });
    window.addEventListener('touchmove', function (e) { if (dragging) { angle += (px(e) - lastX) * 0.55; lastX = px(e); render(); } }, { passive: true });
    window.addEventListener('mouseup', function () { dragging = false; });
    window.addEventListener('touchend', function () { dragging = false; });
    stage.setAttribute('tabindex', '0');
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { angle -= 15; render(); e.preventDefault(); }
      if (e.key === 'ArrowRight') { angle += 15; render(); e.preventDefault(); }
    });
    function sync(input) {
      var i = input.getAttribute('data-tl-input');
      var val = input.value.toUpperCase().slice(0, MAX);
      var t = $('[data-tl-row="' + i + '"] textPath', root);
      if (t) t.textContent = val;
      var row = input.closest('.imprint-row');
      if (!row) return;
      $$('.gauge i', row).forEach(function (tick, n) { tick.classList.toggle('on', n < val.length); });
      row.classList.toggle('full', val.length === MAX);
    }
    $$('[data-tl-input]', root).forEach(function (i) {
      i.addEventListener('input', function () { sync(i); }); sync(i);
    });
    render();
  }

  /* ---- FAQ -------------------------------------------------------------- */
  function initFaq() {
    $$('[data-tl-faq]').forEach(function (btn) {
      if (btn.dataset.ready === 'true') return;
      btn.dataset.ready = 'true';
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item'), panel = $('.faq-a', item);
        var open = item.classList.toggle('open');
        panel.style.maxHeight = open ? (reduce ? 'none' : panel.scrollHeight + 'px') : null;
      });
    });
    $$('[data-tl-cat]').forEach(function (tab) {
      if (tab.dataset.ready === 'true') return;
      tab.dataset.ready = 'true';
      tab.addEventListener('click', function () {
        var group = tab.closest('.help-layout');
        $$('[data-tl-cat]', group).forEach(function (t) { t.classList.toggle('active', t === tab); });
        $$('[data-tl-panel]', group).forEach(function (p) {
          p.style.display = p.getAttribute('data-tl-panel') === tab.getAttribute('data-tl-cat') ? 'block' : 'none';
        });
      });
    });
  }

  /* ---- one-page nav ------------------------------------------------------ */
  function initNav() {
    var nav = $('[data-tl-nav]');
    if (!nav || nav.dataset.ready === 'true') return;
    nav.dataset.ready = 'true';
    var links = $$('a[data-tl-anchor]', nav), bar = $('[data-tl-indicator]', nav);
    if (!links.length) return;
    function slide(a) {
      if (!bar || !a) return;
      bar.style.width = a.offsetWidth + 'px';
      bar.style.transform = 'translateX(' + a.offsetLeft + 'px)';
      bar.classList.add('on');
    }
    function setCurrent(id) {
      var match = null;
      links.forEach(function (a) {
        var on = a.getAttribute('data-tl-anchor') === id;
        a.setAttribute('aria-current', on ? 'true' : 'false');
        if (on) match = a;
      });
      slide(match);
    }
    links.forEach(function (a) {
      a.addEventListener('click', function () { setCurrent(a.getAttribute('data-tl-anchor')); });
      a.addEventListener('mouseenter', function () { slide(a); });
    });
    nav.addEventListener('mouseleave', function () {
      var cur = $('a[aria-current="true"]', nav);
      if (cur) slide(cur); else if (bar) bar.classList.remove('on');
    });
    /* Scroll spy. Ratio-based observers pick whichever section happens to overlap the
       most, which lags a section behind on long pages. Measuring which section has
       crossed a line just under the header is deterministic and always lands on the
       one you are actually looking at. */
    var targets = links.map(function (a) {
      var el = document.getElementById(a.getAttribute('data-tl-anchor'));
      return el ? { link: a, el: el } : null;
    }).filter(Boolean);

    if (targets.length) {
      var ticking = false, lastId = null;

      function activeId() {
        var line = (document.querySelector('[data-tl-header]') || {}).offsetHeight || 88;
        line += 48;   // must clear the scroll-margin a nav click lands on, or the previous section stays lit
        var doc = document.documentElement;
        /* at the very bottom nothing new can cross the line, so pin to the last section */
        if (window.innerHeight + window.pageYOffset >= doc.scrollHeight - 4) {
          return targets[targets.length - 1].el.id;
        }
        var current = null;
        for (var n = 0; n < targets.length; n++) {
          if (targets[n].el.getBoundingClientRect().top <= line) current = targets[n];
        }
        return current ? current.el.id : null;
      }

      function spy() {
        ticking = false;
        var id = activeId();
        if (id && id !== lastId) { lastId = id; setCurrent(id); }
      }
      function onScroll() {
        if (!ticking) { ticking = true; window.requestAnimationFrame(spy); }
      }
      function absTop(el){ return el.getBoundingClientRect().top + window.pageYOffset; }
      targets.sort(function (a, b) { return absTop(a.el) - absTop(b.el); });
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      spy();
    }
    window.addEventListener('resize', function () {
      var cur = $('a[aria-current="true"]', nav); if (cur) slide(cur);
    });
    if (location.hash) setCurrent(location.hash.slice(1));
  }

  function initMenu() {
    var btn = $('[data-tl-menu]'), menu = $('[data-tl-mobile-menu]');
    if (!btn || !menu || btn.dataset.ready === 'true') return;
    btn.dataset.ready = 'true';
    btn.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    $$('a', menu).forEach(function (a) {
      a.addEventListener('click', function () {
        menu.classList.remove('open'); btn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---- Royal Mail tracking ---------------------------------------------- */
  function initTracking() {
    var form = $('[data-tl-track]');
    if (!form || form.dataset.ready === 'true') return;
    form.dataset.ready = 'true';
    var input = $('[data-tl-track-input]', form), err = $('[data-tl-track-error]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = (input.value || '').replace(/[\s-]/g, '').toUpperCase();
      var ok = /^[A-Z0-9]{9,27}$/.test(id);
      if (err) err.hidden = ok;
      if (!ok) { input.focus(); return; }
      window.open('https://www.royalmail.com/track-your-item?trackNumber=' + encodeURIComponent(id), '_blank', 'noopener');
    });
    input.addEventListener('input', function () { if (err) err.hidden = true; });
  }

  /* ---- cart drawer ------------------------------------------------------- */
  function initCart() {
    var drawer = $('[data-tl-cart-drawer]'), overlay = $('[data-tl-cart-overlay]');
    if (!drawer) return;
    function open()  { drawer.classList.add('open'); overlay.classList.add('open'); drawer.setAttribute('aria-hidden','false'); }
    function close() { drawer.classList.remove('open'); overlay.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); }
    $$('[data-tl-cart-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-tl-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    /* add to cart without leaving the page, then refresh the drawer markup */
    var form = $('#product-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('[name="add"]', form);
        if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js',
              { method: 'POST', body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { return fetch(location.pathname + '?section_id=' + 'cart-refresh'); })
          .catch(function () {})
          .then(function () { location.reload(); });
      });
    }
  }

  /* two contact forms share a posted state — keep the confirmation on the right one */
  function scopeSuccess() {
    var notes = $$('[data-tl-success]');
    if (notes.length < 2) return;
    var hash = (location.hash || '').replace('#', '');
    if (!hash) return;
    notes.forEach(function (n) { if (n.getAttribute('data-tl-success') !== hash) n.style.display = 'none'; });
  }

  function boot() {
    $$('[data-tl-rose]').forEach(initRose);
    initFaq(); initNav(); initMenu(); initTracking(); initCart(); scopeSuccess();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();


/* ---- dispatch countdown ---------------------------------------------------
   Counts down to the studio's real cut-off and rolls forward to the next working
   day once it passes. It does not restart on refresh and makes no claim about a
   discount ending, because neither would be true. */
(function () {
  var nodes = [].slice.call(document.querySelectorAll('[data-tl-countdown]'));
  if (!nodes.length) return;
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function isWorkingDay(d) { var k = d.getDay(); return k !== 0 && k !== 6; }
  function nextWorkingDay(d) { var n = new Date(d); do { n.setDate(n.getDate() + 1); } while (!isWorkingDay(n)); return n; }

  function label(d, now) {
    var t = new Date(now); t.setHours(0, 0, 0, 0);
    var x = new Date(d);   x.setHours(0, 0, 0, 0);
    var diff = Math.round((x - t) / 86400000);
    if (diff === 0) return 'today';
    if (diff === 1) return 'tomorrow';
    if (diff < 7) return DAYS[d.getDay()];
    return DAYS[d.getDay()] + ' ' + d.getDate();
  }

  function tick() {
    var now = new Date();
    nodes.forEach(function (n) {
      var hour = parseInt(n.getAttribute('data-cutoff-hour'), 10) || 14;
      var out = n.querySelector('[data-tl-countdown-text]');
      var cut = new Date(now); cut.setHours(hour, 0, 0, 0);
      var dispatch, missed = false;

      if (isWorkingDay(now) && now < cut) {
        dispatch = new Date(now);
      } else {
        missed = true;
        dispatch = nextWorkingDay(now);
        cut = new Date(dispatch); cut.setHours(hour, 0, 0, 0);
      }
      var arrive = nextWorkingDay(dispatch);
      var ms = cut - now;
      var h = Math.floor(ms / 3600000);
      var m = Math.floor((ms % 3600000) / 60000);
      var s = Math.floor((ms % 60000) / 1000);
      var left = h > 0 ? (h + 'h ' + m + 'm') : (m + 'm ' + s + 's');

      if (!missed) {
        out.textContent = 'Order within ' + left + ' and we print it today — arrives ' + label(arrive, now);
      } else {
        out.textContent = 'Next print run is ' + label(dispatch, now) + ' — order within ' + left + ' to make it';
      }
      n.classList.toggle('urgency--soon', ms < 3 * 3600000);
    });
  }
  tick();
  setInterval(tick, 1000);
})();

/* ---- sticky buy bar: appears once the hero is out of view ---------------- */
(function () {
  var bar = document.querySelector('[data-tl-sticky]');
  var hero = document.querySelector('.hero');
  if (!bar || !hero || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        bar.hidden = true; bar.classList.remove('show');
        document.body.classList.remove('has-sticky');
      } else {
        bar.hidden = false;
        document.body.classList.add('has-sticky');
        requestAnimationFrame(function () { bar.classList.add('show'); });
      }
    });
  }, { threshold: 0.12 }).observe(hero);
})();


/* ---- gift add-ons: quick add. Safe to one-tap because these carry no personalisation. */
(function () {
  var btns = [].slice.call(document.querySelectorAll('[data-tl-addon]'));
  if (!btns.length) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  btns.forEach(function (b) {
    b.addEventListener('click', function () {
      var was = b.textContent;
      b.disabled = true; b.textContent = 'Adding…';
      fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: b.getAttribute('data-tl-addon'), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        b.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('tl:cart-changed'));
        setTimeout(function () { b.textContent = was; b.disabled = false; }, 1800);
      }).catch(function () {
        b.textContent = 'Try again'; b.disabled = false;
      });
    });
  });
})();

/* ---- gift note saved onto the order, debounced ---- */
(function () {
  var box = document.querySelector('[data-tl-giftnote]');
  if (!box) return;
  var ta = box.querySelector('textarea');
  var count = box.querySelector('[data-tl-note-count]');
  var state = box.querySelector('[data-tl-note-state]');
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var timer;
  function paint() { if (count) count.textContent = (ta.value || '').length; }
  paint();
  ta.addEventListener('input', function () {
    paint();
    if (state) state.textContent = '';
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: ta.value })
      }).then(function () { if (state) state.textContent = 'Saved'; })
        .catch(function () { if (state) state.textContent = 'Not saved — try again'; });
    }, 700);
  });
})();

/* ---- stem buttons drive the real variant select ---- */
(function () {
  var btns = [].slice.call(document.querySelectorAll('[data-tl-stem]'));
  var sel = document.getElementById('variant-select');
  if (!btns.length || !sel) return;
  btns.forEach(function (b) {
    b.addEventListener('click', function () {
      var want = b.getAttribute('data-tl-stem');
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].text.indexOf(want) !== -1) { sel.selectedIndex = i; break; }
      }
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      btns.forEach(function (o) { o.setAttribute('aria-pressed', o === b); });
    });
  });
})();


/* ---- announcement bar: rotates, pauses on hover or focus, stops on reduced motion ---- */
(function () {
  var bar = document.querySelector('[data-tl-announce]');
  if (!bar) return;
  var msgs = [].slice.call(bar.querySelectorAll('[data-tl-announce-msg]'));
  if (msgs.length < 2) return;
  var i = 0, timer = null;
  var wait = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function show(next) {
    var from = msgs[i];
    i = (next + msgs.length) % msgs.length;
    from.classList.remove('on');
    from.classList.add('out');
    setTimeout(function () { from.classList.remove('out'); }, 450);
    msgs[i].classList.add('on');
  }
  function play() { if (!still) { stop(); timer = setInterval(function () { show(i + 1); }, wait); } }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }

  var prev = bar.querySelector('[data-tl-announce-prev]');
  var next = bar.querySelector('[data-tl-announce-next]');
  if (prev) prev.addEventListener('click', function () { show(i - 1); play(); });
  if (next) next.addEventListener('click', function () { show(i + 1); play(); });
  bar.addEventListener('mouseenter', stop);
  bar.addEventListener('mouseleave', play);
  bar.addEventListener('focusin', stop);
  bar.addEventListener('focusout', play);
  document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });
  play();
})();


/* ---- next occasion: whichever order-by date comes first, then it rolls on ---- */
(function () {
  var box = document.querySelector('[data-tl-deadline]');
  if (!box) return;
  var nodes = [].slice.call(box.querySelectorAll('[data-occ]'));
  if (!nodes.length) { box.hidden = true; return; }
  var list = nodes.map(function (n) {
    return { name: n.getAttribute('data-name'), date: n.getAttribute('data-date'),
             lead: parseInt(n.getAttribute('data-lead'), 10) || 0,
             verb: n.getAttribute('data-verb') || '' };
  });
  if (!list.length) return;

  var nameEl = box.querySelector('[data-dl-name]');
  var byEl = box.querySelector('[data-dl-by]');
  var clockEl = box.querySelector('[data-dl-clock]');
  var DAY = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  /* MM-DD repeats every year, so roll it to the next occurrence rather than letting
     it expire. A full date is treated as a one-off. */
  function occurrence(raw, now) {
    if (!raw) return null;
    var p = raw.split('-').map(Number);
    if (p.length === 3 && p[0] > 1900) return new Date(p[0], p[1] - 1, p[2], 12, 0, 0);
    if (p.length === 2) {
      var d = new Date(now.getFullYear(), p[0] - 1, p[1], 12, 0, 0);
      if (d < now) d = new Date(now.getFullYear() + 1, p[0] - 1, p[1], 12, 0, 0);
      return d;
    }
    return null;
  }

  function pick() {
    var now = new Date(), best = null;
    list.forEach(function (o) {
      var when = occurrence(o.date, now);
      if (!when) return;
      var by = new Date(when);
      by.setDate(by.getDate() - (o.lead || 3));
      by.setHours(23, 59, 0, 0);
      if (by <= now) return;                       // deadline gone, skip to the next
      if (!best || by < best.by) best = { name: o.name, by: by, verb: o.verb };
    });
    return best;
  }

  function tick() {
    var next = pick();
    if (!next) { box.hidden = true; return; }
    box.hidden = false;
    nameEl.textContent = next.name;
    var verbEl = box.querySelector('[data-dl-verb]');
    if (verbEl) verbEl.textContent = next.verb && next.verb.length ? next.verb : (box.getAttribute('data-verb') || 'order by');
    byEl.textContent = DAY[next.by.getDay()] + ' ' + next.by.getDate() + ' ' + MON[next.by.getMonth()];
    var ms = next.by - new Date();
    var d = Math.floor(ms / 86400000), h = Math.floor(ms % 86400000 / 3600000), m = Math.floor(ms % 3600000 / 60000);
    clockEl.textContent = d > 0 ? (d + 'd ' + h + 'h left') : (h + 'h ' + m + 'm left');
  }
  tick();
  setInterval(tick, 60000);
})();


/* ---- character limits -----------------------------------------------------
   Three rules have to agree: a per-row cap, whether spaces count, and a shared
   budget across the rows in a group. maxlength can express none of them, so the
   limit lives here and the gauges read the same numbers. */
window.TL = window.TL || {};
window.TL.countChars = function (v, countSpaces) {
  return countSpaces ? (v || '').length : (v || '').replace(/\s/g, '').length;
};
window.TL.clampChars = function (v, max, countSpaces) {
  if (countSpaces) return (v || '').slice(0, max);
  var out = '', n = 0;
  for (var i = 0; i < (v || '').length; i++) {
    var ch = v[i];
    if (/\s/.test(ch)) { out += ch; continue; }
    if (n >= max) break;
    out += ch; n++;
  }
  return out;
};

(function () {
  function rowMax(inp) { return parseInt(inp.getAttribute('data-max-chars'), 10) || 15; }
  function spacesCount(inp) { return inp.getAttribute('data-count-spaces') === 'true'; }
  function groupOf(inp) { return inp.closest('[data-char-group]'); }

  function used(group) {
    var total = 0;
    [].slice.call(group.querySelectorAll('.imprint-row input')).forEach(function (n) {
      if (n.closest('.imprint-row').hidden) return;
      total += window.TL.countChars(n.value, spacesCount(n));
    });
    return total;
  }

  function paintGroup(group) {
    if (!group) return;
    var budget = parseInt(group.getAttribute('data-budget'), 10) || 0;
    var out = group.querySelector('[data-char-total]');
    if (out && budget) {
      var u = used(group);
      out.textContent = u + ' of ' + budget;
      group.classList.toggle('at-limit', u >= budget);
    }
  }

  function paintRow(row) {
    if (!row) return;
    var inp = row.querySelector('input'), g = row.querySelector('.gauge');
    if (!inp || !g) return;
    var max = rowMax(inp);
    while (g.children.length < max) g.appendChild(document.createElement('i'));
    while (g.children.length > max) g.removeChild(g.lastChild);
    var n = window.TL.countChars(inp.value, spacesCount(inp));
    [].slice.call(g.children).forEach(function (t, k) { t.classList.toggle('on', k < n); });
    row.classList.toggle('full', n >= max);
  }

  function handle(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var row = t.closest('.imprint-row');
    if (!row) return;
    var group = groupOf(t);
    var max = rowMax(t), spaces = spacesCount(t);

    /* the row cap first, then whatever is left of the shared budget */
    var v = window.TL.clampChars(t.value, max, spaces);
    if (group) {
      var budget = parseInt(group.getAttribute('data-budget'), 10) || 0;
      if (budget) {
        var others = 0;
        [].slice.call(group.querySelectorAll('.imprint-row input')).forEach(function (n) {
          if (n === t || n.closest('.imprint-row').hidden) return;
          others += window.TL.countChars(n.value, spacesCount(n));
        });
        var allowance = Math.max(0, budget - others);
        v = window.TL.clampChars(v, Math.min(max, allowance), spaces);
      }
    }
    if (v !== t.value) {
      var at = t.selectionStart;
      t.value = v;
      try { t.setSelectionRange(Math.min(at, v.length), Math.min(at, v.length)); } catch (err) {}
    }
    paintRow(row);
    paintGroup(group);
  }

  document.addEventListener('input', handle);
  function init() {
    [].slice.call(document.querySelectorAll('.imprint-row')).forEach(paintRow);
    [].slice.call(document.querySelectorAll('[data-char-group]')).forEach(paintGroup);
  }
  document.addEventListener('DOMContentLoaded', init);
  init();
  window.TL.refreshLimits = init;
})();


/* ---- keep the free-delivery bar honest after an AJAX add ---- */
(function () {
  function refresh() {
    var box = document.querySelector('[data-tl-freeship]');
    if (!box) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var target = parseInt(box.getAttribute('data-target'), 10) || 0;
      if (!target) return;
      var left = target - cart.total_price;
      var msg = box.querySelector('[data-tl-freeship-msg]');
      var fill = box.querySelector('[data-tl-freeship-fill]');
      var away = box.getAttribute('data-away') || '[amount] away from free delivery';
      var won = box.getAttribute('data-won') || 'Free delivery unlocked';
      if (left > 0) {
        msg.textContent = away.replace('[amount]', '£' + (left / 100).toFixed(2));
        box.classList.remove('freeship--won');
      } else {
        msg.textContent = won;
        box.classList.add('freeship--won');
      }
      fill.style.width = Math.min(100, cart.total_price / target * 100) + '%';
    }).catch(function () {});
  }
  document.addEventListener('tl:cart-changed', refresh);
})();


/* ---- remove a line from the drawer without a page reload ---- */
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-tl-remove]');
    if (!link) return;
    e.preventDefault();
    var line = parseInt(link.getAttribute('data-tl-remove'), 10);
    if (!line) { window.location.href = link.getAttribute('href'); return; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    link.textContent = 'Removing…';
    fetch(root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
    .then(function (r) { if (!r.ok) throw new Error('remove'); return r.json(); })
    .then(function () {
      document.dispatchEvent(new CustomEvent('tl:cart-changed'));
      var item = link.closest('.cart-item');
      if (item) item.remove();
      if (!document.querySelector('.cart-item')) window.location.reload();
    })
    .catch(function () { window.location.href = link.getAttribute('href'); });
  });
})();
